<div class="legal-container">
  <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1.5rem;">
    <h1 style="margin: 0;">Innovadoc IA</h1>
    <ng-container *ngIf="!(isAuthenticated$ | async)">
      <div style="display:flex; gap: 0.75rem; align-items: center;">
        <a (click)="goToLogin()"
           style="color: var(--link); text-decoration: underline; font-weight: 500; font-size: 1.08rem; cursor: pointer;">
          Iniciar sesión
        </a>
        <span style="opacity:.7;">·</span>
        <a (click)="goToSignup()"
           style="color: var(--link); text-decoration: underline; font-weight: 500; font-size: 1.08rem; cursor: pointer;">
          Registrarse
        </a>
      </div>
    </ng-container>
  </div>
  <p>
    <strong>Innovadoc IA</strong> es una plataforma líder en inteligencia artificial y automatización de procesos
    empresariales. Nuestra misión es impulsar la innovación, la eficiencia y la transformación digital en organizaciones
    de todos los tamaños.
  </p>
  <h2>¿Quiénes somos?</h2>
  <p>
    Somos un equipo multidisciplinario de expertos en IA, desarrollo de software y consultoría tecnológica. Desde 2020,
    ayudamos a empresas a optimizar sus operaciones, tomar mejores decisiones y crear productos inteligentes.
  </p>
  <h2>Servicios principales</h2>
  <ul>
    <li>Automatización de procesos con IA y RPA</li>
    <li>Desarrollo de asistentes virtuales y chatbots</li>
    <li>Integración de modelos de lenguaje y análisis de datos</li>
    <li>Consultoría en transformación digital y adopción de IA</li>
    <li>Soluciones personalizadas para sectores salud, legal, educación y más</li>
  </ul>
  <h2>Política de Privacidad y Protección de Datos</h2>
  <p>
    En Innovadoc IA, la privacidad y seguridad de los datos de nuestros usuarios es una prioridad. Cumplimos con todas
    las regulaciones aplicables en materia de protección de datos, incluyendo GDPR y normativas locales.
  </p>
  <ul>
    <li>No compartimos información personal con terceros sin consentimiento explícito.</li>
    <li>Los datos recopilados se utilizan únicamente para mejorar nuestros servicios y experiencia de usuario.</li>
    <li>Los usuarios pueden solicitar la eliminación o rectificación de sus datos en cualquier momento.</li>
    <li>Implementamos medidas técnicas y organizativas para proteger la información almacenada.</li>
    <li>Solo almacenamos datos el tiempo estrictamente necesario para los fines declarados.</li>
  </ul>
  <h3>Compromiso ético</h3>
  <p>
    Innovadoc IA promueve el uso responsable y ético de la inteligencia artificial. Nos comprometemos a:
  </p>
  <ul>
    <li>Evitar sesgos y discriminación en nuestros modelos y soluciones.</li>
    <li>Garantizar la transparencia en el uso de algoritmos y datos.</li>
    <li>Respetar la autonomía y privacidad de los usuarios.</li>
  </ul>
  <h3>Contacto</h3>
  <p>
    Para más información, solicitudes de privacidad o reportar incidentes, contáctanos en:
    <a href="mailto:admin@innovadoc-ia.com">admin&#64;innovadoc-ia.com</a>
  </p>
  <p>
    Dirección: Calle 146a #58b-22, bogota, Colombia<br>
    Teléfono: +57 3008722905
  </p>
  <h4>© 2020-2025 Innovadoc IA. Todos los derechos reservados.</h4>
  <footer style="margin-top: 2.5rem; text-align: center; font-size: 1rem; opacity: 0.85;">
    <a routerLink="/privacy" style="color: var(--link); text-decoration: underline; margin-right: 1.5rem;">Política de
      privacidad</a>
    <a routerLink="/terms" style="color: var(--link); text-decoration: underline;">Términos de servicio</a>
  </footer>
</div>
